import { render, staticRenderFns } from "./CategoryPageListView.vue?vue&type=template&id=0c5a084f&scoped=true"
import script from "./CategoryPageListView.vue?vue&type=script&lang=js"
export * from "./CategoryPageListView.vue?vue&type=script&lang=js"
import style0 from "./CategoryPageListView.vue?vue&type=style&index=0&id=0c5a084f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5a084f",
  null
  
)

export default component.exports